// src/utils/Constantes.js
// DECLARACIÓN DE CONSTANTES PARA LA CONFIGURACIÓN DE RUTAS DE BACKEND, SE UTILIZA PARA FACILITAR EL CAMBIO ENTRE BACK LOCAL Y BACK DE PRUEBAS.
/*
    AYUDA PARA EL JR:
    PARA PRODUCTIVO:
    - esDesarrollo: false
    - esLocal: false

    PARA PRUEBAS:
    - esDesarrollo: true
    - esLocal: false

    PARA LOCAL:
    - esDesarrollo: true
    - esLocal: true
*/

// CONVERTIMOS LAS VARIABLES DE ENTORNO A BOOLEANOS REALES.
// IMPORTANTE: process.env siempre entrega strings.
const convertirBooleano = (valor) => {
    return String(valor).trim().toLowerCase() === 'true';
};

const esDesarrollo = convertirBooleano(process.env.REACT_APP_ES_DESARROLLO);
const esLocal = convertirBooleano(process.env.REACT_APP_ES_LOCAL);

// const esDesarrollo = process.env.REACT_APP_ES_DESARROLLO; //SI ES TRUE, APUNTA A BACK DE PRUEBAS, SI ES FALSE APUNTA A BACK DE PRODUCTIVO.
// const esLocal = process.env.REACT_APP_ES_LOCAL; //PRUEBAS LOCAL, APUNTA A BACK LOCAL, SI ES FALSE APUNTA A BACK DE PRUEBAS.

// RUTAS DE BACKEND PARA PRUEBAS, LOCAL Y PRODUCCIÓN(PENDIENTE).
const backPruebas = process.env.REACT_APP_URL_PRUEBA || '';
const backLocal = process.env.REACT_APP_URL_LOCAL || '';
const backProduccion = process.env.REACT_APP_URL_PRODUCCION || '';

// CENTRALIZAMOS EL TITULO DE LA APLICACIÓN EN UNA CONSTANTE PARA FACILITAR SU CAMBIO Y MANTENER LA CONSISTENCIA EN TODA LA APLICACIÓN.
const tituloOriginal = 'CAPACITACION & UNIVERSIDAD MADERAS - CIUDAD MADERAS';

// MARCAMOS EL AMBIENTE EN EL TITULO DE LA APLICACIÓN PARA FACILITAR LA IDENTIFICACIÓN DEL AMBIENTE EN EL QUE SE ESTÁ TRABAJANDO, ESPECIALMENTE EN PRUEBAS Y LOCAL.
const tituloApp = `${esDesarrollo ? (esLocal ? '(PRUEBAS LOCAL)-' : '(PRUEBAS)-') : ''}${tituloOriginal}`;

const raiz = esLocal ? backLocal : esDesarrollo ? backPruebas : backProduccion;

if (!raiz) {
    console.error('No se encontró URL de backend para el ambiente configurado.', {
        esDesarrollo,
        esLocal,
        tieneBackLocal: Boolean(backLocal),
        tieneBackPruebas: Boolean(backPruebas),
        tieneBackProduccion: Boolean(backProduccion)
    });
}

export default {
    esDesarrollo,
    esLocal,
    tituloApp,
    raiz,
    raizBack: raiz
};
